import { urls } from '../constants';
import { Get } from '../fetch';
export async function loadEntitlementsV2() {
  return Get(urls.entitlements.v2);
}